import React from "react";
// import "../styles/Credits.css";
import FadeInSection from "./FadeInSection";
import "../styles/Impact.css";

class Impact extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    return (
        <div id="impact">
          
        <FadeInSection>
          <div className="section-header ">
            <span className="section-title">/Impact</span>
          </div>
          <br></br>
          <div className="about-content"><br /><br /><br /><br />
          <div className="about-description"> 
          <a href="https://www.hhs.gov/sites/default/files/surgeon-general-social-connection-advisory.pdf" target="_blank" rel="noopener noreferrer" className="formatted-link">
            <img alt="epidemic" width= "400px" src={"/assets/loneliness.png"} /> 
            </a>
          
         </div>
          <div style={{ marginLeft: '30px' }} className="about-description"> <br /><br />
          <p>
                In today’s world, the epidemic of loneliness has become a significant public health concern, as highlighted in the
                <a href="https://www.hhs.gov/sites/default/files/surgeon-general-social-connection-advisory.pdf" target="_blank" rel="noopener noreferrer"> Surgeon General's Advisory on Social Connection
                </a>.
                Disconnection is not only affecting our mental and emotional well-being but also leading to tangible health risks. GroupMatch is a solution designed to foster meaningful relationships and rebuild the fabric of social connection. By matching individuals with shared interests and goals, GroupMatch provides a platform for forming authentic connections and reducing the isolation many people feel in their daily lives. Together, we can combat loneliness and create a society where everyone feels a sense of belonging and community.
            </p>
          </div>
          </div>
         <div style={{ maxWidth: "900px", width: "100%", margin: "0 auto" }}  className="about-description"> <br /><br /><h2>Tools/ Resources</h2>
         
  <li>
    Mental health platforms - 
    <a href="https://www.wondermind.com/" target="_blank" rel="noopener noreferrer">Wondermind</a>
    <p>We teamed up with mental health platform Wondermind. They can help you navigate all the feelings that come with the holidays and deepen your relationships.</p>
  </li>
  <li>
    Support for stress management - 
    <a href="https://www.headspace.com/" target="_blank" rel="noopener noreferrer">Headspace</a>
    <p>Headspace offers meditation and mindfulness practices to help you manage stress, stay focused, and improve mental well-being.</p>
  </li>
  <li>
    Building better relationships - 
    <a href="https://www.gottman.com/" target="_blank" rel="noopener noreferrer">Gottman Institute</a>
    <p>The Gottman Institute provides science-based tools and strategies for building healthier, lasting relationships.</p>
  </li>
  <li>
    Mental wellness support - 
    <a href="https://www.betterhelp.com/" target="_blank" rel="noopener noreferrer">BetterHelp</a>
    <p>BetterHelp connects you with licensed therapists online for convenient and private therapy sessions to support your mental wellness.</p>
  </li>


         </div>
        </FadeInSection>
      </div>
    );
  }
}

export default Impact;
